export default __webpack_public_path__ + "static/media/photomontage.dee5bf56.webp";